<template>
  <v-container>
    <h1 class="display-1 pt-3">{{ courseName }} Users</h1>
    <a-l-dayresponses class="mt-2" :courseid="courseID" />
  </v-container>
</template>
<script>
import dayresponses from "../../components/bycourse";
import service from "@/services/index.js";
export default {
  props: ["courseid"],
  components: {
    "a-l-dayresponses": dayresponses
  },
  data: () => ({
    course: null
  }),
  computed: {
    courseID() {
      if (!this.course) {
        return null;
      }
      return this.course._id;
    },
    courseName() {
      if (!this.course) {
        return "";
      }
      return this.course.name || "";
    }
  },
  methods: {
    async onLoad() {
      this.$store.commit("setLoading", true);
      let course = await service.course.getOne({
        type: "publisher",
        id: this.courseid
      });
      this.$store.commit("setLoading", false);

      this.course = course;
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>
